export default __webpack_public_path__ + "static/media/global client portfolio.1b8932a4.svg";